import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface Profile {
  roles: Array<{ key: string; name: string }>;
  primaryRole: { key: string; name: string } | null;
  canSocio: boolean;
  unit: { id: string; name: string } | null;
}

/** Papel principal, unidade da pessoa e se vê a Visão do sócio. */
export function useProfile() {
  return useQuery({ queryKey: ["painel-perfil"], queryFn: () => api.get<Profile>("/painel/perfil"), staleTime: 300_000 });
}
